"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogisticsClient = exports.MalformedMutationData = exports.Operation = exports.MutateMethods = exports.LogisticsSearchObjectSchema = exports.IngestionEventPriority = void 0;
const base_client_1 = require("@deliverr/base-client");
const core_auth_1 = require("@deliverr/core-auth");
const client_auth_1 = require("@deliverr/client-auth");
const zod_1 = require("zod");
var IngestionEventPriority;
(function (IngestionEventPriority) {
    IngestionEventPriority["LIVE"] = "LIVE";
    IngestionEventPriority["BACKFILL"] = "BACKFILL";
})(IngestionEventPriority = exports.IngestionEventPriority || (exports.IngestionEventPriority = {}));
exports.LogisticsSearchObjectSchema = zod_1.z
    .object({
    id: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]),
    _logisticsSearchMetadata: zod_1.z
        .object({
        ingestionEventTimestamp: zod_1.z.number(),
        ingestionEventPriority: zod_1.z.nativeEnum(IngestionEventPriority),
    })
        .strict(),
})
    .catchall(zod_1.z.unknown());
var MutateMethods;
(function (MutateMethods) {
    MutateMethods["POST"] = "POST";
    MutateMethods["PUT"] = "PUT";
    MutateMethods["DELETE"] = "DELETE";
})(MutateMethods = exports.MutateMethods || (exports.MutateMethods = {}));
var Operation;
(function (Operation) {
    Operation["CREATE"] = "CREATE";
    Operation["UPDATE"] = "UPDATE";
    Operation["DELETE"] = "DELETE";
})(Operation = exports.Operation || (exports.Operation = {}));
class MalformedMutationData extends Error {
    constructor(reason) {
        super(reason);
    }
}
exports.MalformedMutationData = MalformedMutationData;
class LogisticsClient extends base_client_1.ApiClient {
    constructor(indexName, config) {
        if (!config.baseURL) {
            throw new Error("Missing mandatory base url option in LogisticsClient.");
        }
        if ((config === null || config === void 0 ? void 0 : config.authEngine) === core_auth_1.AuthEngine.COGNITO_INTERNAL && !config.tokenRefreshFn) {
            const tokenHandler = new client_auth_1.OAuthClientTokenBuilder(Object.assign(Object.assign({}, config), { useAuthTokenCachingProxy: true }));
            config.tokenRefreshFn = tokenHandler.getTokenFn();
        }
        super(config);
        this.config = config;
        this.indexName = indexName;
    }
    async search(query, params) {
        return super.post(`/documents/${this.indexName}/search`, query, params);
    }
    async count(query) {
        return super.post(`/documents/${this.indexName}/count`, query);
    }
    async mutate(operation, unsanitizedData) {
        const validationResult = zod_1.z.array(exports.LogisticsSearchObjectSchema).safeParse(unsanitizedData);
        if (!validationResult.success) {
            throw new MalformedMutationData(validationResult.error.toString());
        }
        const { data } = validationResult;
        const req = {
            index: this.indexName,
            operation,
            data,
        };
        return super.post("/index", req);
    }
}
exports.LogisticsClient = LogisticsClient;
//# sourceMappingURL=LogisticsClient.js.map